import { z } from 'zod';

/**
 * Zod validation schema for frame creation/update
 */
export const frameSchema = z
  .object({
    location_id: z.string().uuid('Please select a location'),
    manufacturer_id: z.string().uuid('Please select a manufacturer'),
    brand: z.string().min(1, 'Brand is required').max(100, 'Brand must be 100 characters or less'),
    frame_name_or_model: z
      .string()
      .min(1, 'Frame name/model is required')
      .max(100, 'Frame name must be 100 characters or less'),
    color: z.string().min(1, 'Color is required').max(50, 'Color must be 50 characters or less'),
    eye_size: z
      .string()
      .min(1, 'Eye size is required')
      .max(20, 'Eye size must be 20 characters or less'),
    order_type: z.enum(['STOCK', 'PATIENT'], {
      errorMap: () => ({ message: 'Please select order type' }),
    }),
    patient_name: z.string().max(100, 'Patient name must be 100 characters or less').optional(),
    tray_number: z.string().max(50, 'Tray number must be 50 characters or less').optional(),
    notes: z.string().max(500, 'Notes must be 500 characters or less').optional(),
  })
  .refine(
    (data) => {
      // If order type is PATIENT, patient_name and tray_number are required
      if (data.order_type === 'PATIENT') {
        return !!data.patient_name && !!data.tray_number;
      }
      return true;
    },
    {
      message: 'Patient name and tray number are required for patient orders',
      path: ['patient_name'],
    }
  );

export type FrameFormData = z.infer<typeof frameSchema>;
